import { OptionsToggle } from './OptionsToggle';
import { Options } from './Options';
import { GamepadToggle } from './GamepadToggle';

declare global {
  interface Navigator {
    keyboard: {
      lock: () => Promise<undefined>;
    };
  }
}

export const Overlay = () => {
  return (
    <div className='absolute h-full w-full h-max-full w-max-full flex flex-col justify-center z-50'>
      <OptionsToggle />
      <Options />
    </div>
  );
};
